import { Component, Input, ViewChild, ElementRef, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { Corporate } from "src/app/parametrage/core/model/corporate";
import { EntrepriseService } from "src/app/parametrage/core/service/entreprise.service";
import { CustomerLegalForm } from "src/app/parametrage/core/model/customer-legal-form";
import { ActivityArea } from "src/app/parametrage/core/model/activity-area";
import { ActivityAreaService } from "src/app/parametrage/core/service/activity-area.service";
import { CustomerLegalFormService } from "src/app/parametrage/core/service/customer-legal-form.service";

@Component({
  selector: "app-update-info-entreprise",
  templateUrl: "./update-info-entreprise.component.html",
  styleUrls: ["./update-info-entreprise.component.scss"],
})
export class UpdateInfoEntrepriseComponent implements OnInit {
  @Input() corporateId;

  corporate: Corporate;

  legalForms: CustomerLegalForm[];
  secteurs: ActivityArea[];

  form2: FormGroup;
  pressButton: Boolean = false;
  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _entrepriseService: EntrepriseService,
    private _activityAreaService: ActivityAreaService,
    private _customerLegalFormService: CustomerLegalFormService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      customerCode: [null, Validators.compose([Validators.nullValidator])],
      corporateName: [null, Validators.compose([Validators.required])],
      tradeRegister: [null, Validators.compose([Validators.required])],
      ncc: [null, Validators.compose([Validators.required])],
      activityArea: [null, Validators.compose([Validators.required])],
      customerLegalForm: [null, Validators.compose([Validators.required])],
      city: [null, Validators.compose([Validators.nullValidator])],
      address: [null, Validators.compose([Validators.nullValidator])],
      email: [null, Validators.compose([Validators.nullValidator])],
      workPhone: [null, Validators.compose([Validators.nullValidator])],
      firstname: [null, Validators.compose([Validators.required])],
      lastname: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getCorporateById(this.corporateId);
    this.getAllLegalForm();
    this.getAllSecteur();
  }

  getCorporateById(customerId) {
    this._entrepriseService.getCorporateById(customerId).subscribe(
      (data) => {
        this.corporate = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getAllLegalForm() {
    this._customerLegalFormService.getAllLegalForms().subscribe(
      (data) => {
        this.legalForms = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getAllSecteur() {
    const token = localStorage.getItem("token");
    if (token) {
      this._activityAreaService.getAllSecteurs().subscribe(
        (data) => {
          this.secteurs = data;
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  editCustomer(): void {
    this.spinner.show();
    this._entrepriseService
      .putCorporate(this.corporate)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
